import api from './api';

const dashboardService = {
  /**
   * Get dashboard summary for "Needs Attention" section (Owner only)
   * Returns: newLeadsCount, overdueInvoicesCount, readyToInvoiceCount, etc.
   */
  getSummary: async () => {
    const response = await api.get('/dashboard/summary');
    return response.data;
  },

  /**
   * Get optimized job data for dashboard (All users)
   * Returns: todaysJobs, upcomingJobs, recentlyCompleted, counts
   * Much more efficient than loading all jobs and filtering client-side
   */
  getJobs: async () => {
    const response = await api.get('/dashboard/jobs');
    return response.data;
  },

  /**
   * Get financial stats for dashboard (Owner only)
   * Returns: revenueThisWeek, revenueLastWeek, outstandingBalance, scheduledRevenue, totalCustomers
   */
  getStats: async () => {
    const response = await api.get('/dashboard/stats');
    return response.data;
  },

  /**
   * Get user's dashboard widget preferences
   */
  getPreferences: async () => {
    const response = await api.get('/dashboard/preferences');
    return response.data;
  },

  /**
   * Update user's dashboard widget preferences
   */
  updatePreferences: async (preferences) => {
    const response = await api.put('/dashboard/preferences', preferences);
    return response.data;
  },
};

export default dashboardService;